import React, { useState } from 'react';
import { Box, ThemeProvider, Typography, Menu, MenuItem } from '@mui/material';
import { theme } from '../../../../theme/theme';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@mui/material/IconButton';
import downloadIcon from '../../../../assets/SVGs/download-icon.svg';
import { BOGLE_REGULAR, DOWNLOAD_EXCEL } from '../../../../constants/constant';
import TextWithDefinition from '../../../TextWithDefinition';
import { colors } from '../../../../theme/color-palette';

const useStyles = makeStyles(() => ({
	tableHeading: {
		padding: '0px 16px',
		paddingTop: '24px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	button_ellipsis: {
		padding: 0,
	},
}));

const MetricHeader = (props) => {
	const { headerName, definitionId, handleDownload } = props;
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);

	const openMenu = async (event) => {
		setAnchorEl(event.currentTarget);
	};

	const closeMenu = () => {
		setAnchorEl(null);
	};

	return (
		<ThemeProvider theme={theme}>
			<Box className={classes.tableHeading}>
				<TextWithDefinition
					styles={{
						fontWeight: 700,
						fontSize: '18px',
						color: colors?.DARK_GREY,
					}}
					text={headerName}
					hasDefinition={true}
					definitionId={definitionId}
				/>
				<IconButton
					size="medium"
					className={classes.button_ellipsis}
					onClick={openMenu}>
					<img alt="Download" src={downloadIcon} />
				</IconButton>
				<Menu
					keepMounted
					anchorEl={anchorEl}
					onClose={closeMenu}
					open={Boolean(anchorEl)}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}>
					<MenuItem data-test-id="download-excel" onClick={handleDownload}>
						<img alt="Download" src={downloadIcon} />
						<Typography
							sx={{
								fontFamily: `${BOGLE_REGULAR}`,
								marginLeft: '10px',
							}}>
							{DOWNLOAD_EXCEL}
						</Typography>
					</MenuItem>
				</Menu>
			</Box>
		</ThemeProvider>
	);
};

MetricHeader.propTypes = {
	headerName: PropTypes.string,
	definitionId: PropTypes.string,
	handleDownload: PropTypes.func,
};

export default MetricHeader;
